import { ActionMenu } from "@telluscompany/design-system";
import { Eye, MoreVerticalIcon } from "lucide-react";

import { useLocalization } from "@i18n";

import type { ListAdminComplexesResponseItem } from "../../api/complexes";

interface AdminComplexesActionMenuProps {
  complex: ListAdminComplexesResponseItem;
  onViewDetails: (complex: ListAdminComplexesResponseItem) => void;
}

export const AdminComplexesActionMenu = ({
  complex,
  onViewDetails,
}: AdminComplexesActionMenuProps) => {
  const { translate } = useLocalization();

  const actions = [
    {
      actions: [
        {
          label: translate("admin.complexes.button.viewDetails"),
          onClick: () => onViewDetails(complex),
          icon: <Eye size={16} />,
        },
      ],
    },
  ];

  return <ActionMenu menu={actions} trigger={<MoreVerticalIcon />} />;
};
